import React from 'react'
import { Badge, Button } from 'antd'
import { t } from '../../../../config/i18n'
import styles from './Button.module.scss'

interface Props {
  count: number
  onClick: () => void
  onReset: () => void
}

export const FilterButton = ({ count, onClick, onReset }: Props) => (
  <div className={styles.root}>
    <Button
      type="default"
      className={styles.btn}
      onClick={onClick}
    >
      {t.common.filter} {count > 0 && <Badge count={count} className={styles.badge} />}
    </Button>
    {count > 0 && (
      <div className={styles.reset} onClick={onReset}>{t.common.reset.toLowerCase()}</div>
    )}
  </div>
)
